class s extends window.HTMLElement {
  connectedCallback() {
    ;((this.currentPuff = 1),
      (this.dosageImage = this.querySelector('.dosage-image')),
      (this.prevButton = this.querySelector('[data-prev-puff]')),
      (this.nextButton = this.querySelector('[data-next-puff]')),
      (this.puffItems = this.querySelectorAll('.dosage-puff-item')),
      (this.transforms = { 1: 25, 2: 3, 3: -18, 4: -40 }),
      this.prevButton.addEventListener('click', () => this.handlePrev()),
      this.nextButton.addEventListener('click', () => this.handleNext()),
      this.updatePuff(this.currentPuff))
  }
  handlePrev() {
    this.currentPuff > 1 &&
      (this.currentPuff--, this.updatePuff(this.currentPuff))
  }
  handleNext() {
    this.currentPuff < 4 &&
      (this.currentPuff++, this.updatePuff(this.currentPuff))
  }
  updatePuff(e) {
    ;(this.puffItems.forEach(t => {
      t.classList.contains('active') && t.classList.remove('active')
    }),
      setTimeout(() => {
        this.puffItems.forEach(t => {
          parseInt(t.dataset.puff) === e && t.classList.add('active')
        })
      }, 300),
      this.dosageImage &&
        (this.dosageImage.style.transform = `translateX(${this.transforms[e]}%)`),
      (this.prevButton.disabled = e === 1),
      (this.nextButton.disabled = e === 4))
  }
}
window.customElements.define('dosage-slider', s)
